<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Spare Ledger Reports
                    </li>
                </ol>
                <h4 class="main-title mb-0">Spare Ledger Reports</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Spare Ledger Reports</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-3">
                                <label class="form-label">Spare</label>
                                <search
                                    v-if="isSparesLoaded"
                                    :class="{ 'is-invalid': errors.spare_id }"
                                    :customClass="{ 'is-invalid': errors.spare_id }"
                                    aria-describedby="spare-select"
                                    aria-label="Select Spare"
                                    :initialize="user_spare.spare_id"
                                    id="spare_id"
                                    label="spare_name"
                                    label2="spare_code"
                                    placeholder="Select Spare"
                                    :data="spares"
                                    @input="spare1 => user_spare.spare_id = spare1"
                                />
                                <div v-else class="form-control text-muted">Loading spares...</div>
                                <span v-if="errors.spare_id" class="invalid-feedback">{{ errors.spare_id[0] }}</span>
                            </div>
                            <div class="col-3">
                                <label class="form-label">From Date</label>
                                <input
                                    class="form-control mb-2"
                                    type="date"
                                    v-model="meta.from_date"
                                    :class="{ 'is-invalid': errors.from_date }"
                                />
                                <span v-if="errors.from_date" class="invalid-feedback">{{ errors.from_date[0] }}</span>
                            </div>
                            <div class="col-3">
                                <label class="form-label">To Date</label>
                                <input
                                    class="form-control mb-2"
                                    type="date"
                                    v-model="meta.to_date"
                                    :class="{ 'is-invalid': errors.to_date }"
                                />
                                <span v-if="errors.to_date" class="invalid-feedback">{{ errors.to_date[0] }}</span>
                            </div>
                            <div class="col-3 m-auto">
                                <button class="btn btn-primary mt-3 me-2" @click="search">Search</button>
                                <button class="btn btn-danger mt-3" @click="reset">Reset</button>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-sm table-striped table-bordered mb-0">
                                <thead style="background-color:#9b9b9b;color:white;">
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>
                                            Date & Time
                                            <span>
                                                <i v-if="meta.keyword === 'date' && meta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else-if="meta.keyword === 'date' && meta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>
                                            Transaction Reference
                                            <span>
                                                <i v-if="meta.keyword === 'date' && meta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else-if="meta.keyword === 'date' && meta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('inward_quantity')" class="cursor-pointer">
                                            Inward Stock
                                            <span>
                                                <i v-if="meta.keyword === 'inward_quantity' && meta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else-if="meta.keyword === 'inward_quantity' && meta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('outward_quantity')" class="cursor-pointer">
                                            Outward Stock
                                            <span>
                                                <i v-if="meta.keyword === 'outward_quantity' && meta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else-if="meta.keyword === 'outward_quantity' && meta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('closing_stock')" class="cursor-pointer">
                                           Balance
                                            <span>
                                                <i v-if="meta.keyword === 'closing_stock' && meta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else-if="meta.keyword === 'closing_stock' && meta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="stock_summary.length === 0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(item, index) in stock_summary" :key="item.id || index">
                                        <td class="text-center">{{ (meta.from + index) - 1 }}</td>
                                        <td>{{ item?.date}}</td>
                                        <td>{{ item?.transaction_reference }}</td>
                                        <td>{{ item.inward || 0 }}</td>
                                        <td>{{ item.outward || 0 }}</td>
                                        <td>{{ item.balance || 0 }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select form-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option v-for="option in [10, 15, 20, 25, 30]" :key="option" :value="option">{{ option }}</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Search from "@/components/Search.vue";
import Pagination from "@/components/Pagination.vue";
import moment from "moment";

export default {
    components: {
        Pagination,
        Search
    },
    data() {
        return {
            meta: {
                order_by: 'asc',
                keyword: 'spare_id',
                per_page: 10,
                totalRows: 0,
                page: 1,
                lastPage: 1,
                from: 1,
                to: 1,
                maxPage: 1,
                from_date: moment().format('YYYY-MM-DD'),
                to_date: moment().format('YYYY-MM-DD')
            },
            stock_summary: [],
            spares: [],
            user_spare: {
                spare_id: null
            },
            user_service: {}, // Assuming an empty object if not defined elsewhere
            errors: {},
            isSparesLoaded: false
        };
    },
    mounted() {
        this.getSpares();
    },
    methods: {
        index() {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'paginateInventorySpareStocks', data: { ...vm.meta, spare_id: vm.user_spare.spare_id } })
                .then(response => {
                    loader.hide();
                    vm.stock_summary = response.data.data || [];
                    vm.meta.totalRows = response.data.total || 0;
                    vm.meta.page = response.data.current_page || 1;
                    vm.meta.per_page = response.data.per_page || 10;
                    vm.meta.lastPage = response.data.last_page || 1;
                    vm.meta.from = (vm.meta.page - 1) * vm.meta.per_page + 1;
                    const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                    vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || {};
                    vm.$store.dispatch('error', error.response?.data?.message || 'Failed to load data');
                });
        },
        getSpares() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "getAllSpares" })
                .then((response) => {
                    loader.hide();
                    vm.spares = response.data.data || [];
                    vm.isSparesLoaded = true;
                })
                .catch((error) => {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || {};
                    vm.$store.dispatch("error", error.response?.data?.message || "Failed to load spares");
                });
        },
        reset() {
            this.meta = {
                spare_id:"",
                from_date: "",
                to_date: ""
            };
            this.user_spare.spare_id = null;
            this.errors = {};
        },
        search() {
            this.meta.page = 1;
            this.index();
        },
        onPageChange(page) {
            this.meta.page = page;
            this.index();
        },
        onPerPageChange() {
            this.meta.page = 1;
            this.index();
        },
        sort(field) {
            this.meta.keyword = field;
            this.meta.order_by = this.meta.order_by === 'asc' ? 'desc' : 'asc';
            this.index();
        },
        handleSelectSearch(value) {
            console.log('Selected spare:', value);
            this.user_spare.spare_id = value;
            this.search();
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.width-75 {
    width: 75px;
}
.table-responsive {
    overflow-x: auto;
}
</style>